<div class="header">
	<img src="coinstac-logo.png" alt="COINSTAC" style="height: 72px" />
	<h2 style="font-weight: normal; color: grey">
		&nbsp; | Compspec/Inputspec Helper Tool
	</h2>
</div>
<hr />
<div class="panel panel-full">
	<h2>Inputs</h2>
	<hr />
	<Tabs>
	  <TabList>
	    <Tab>Basics</Tab>
	    <Tab>Input Selection</Tab>
	  </TabList>

	  <TabPanel>
	    <h2>Basics</h2>
			<BasicsUI bind:value={basics} />
	  </TabPanel>

	  <TabPanel>
			<h2>Input Selection</h2>
			<SelectsUI bind:value={selects} />
			<!--
			<div class="panel panel-full">
				<h3>Input Object (For Debugging)</h3>
				<textarea class="results">{JSON.stringify(selects)}</textarea>
			</div>
			-->
	  </TabPanel>
	</Tabs>
</div>
<div class="panel panel-full">
	<h2>Outputs</h2>
	<hr />
	<Tabs>
	  <TabList>
	    <Tab>Compspec</Tab>
	    <Tab>Inputspec</Tab>
	  </TabList>
		<TabPanel>
			<div class="flexrow">
				<h2>Compspec</h2>
				<Clipboard
				  text={compspec}
				  let:copy
					on:copy={handleCopied}>
					<button on:click={copy}>{copyState}</button>
				</Clipboard>
			</div>
			<textarea class="results">{compspec}</textarea>
		</TabPanel>
		<TabPanel>
			<div class="flexrow">
				<h2>Inputspec</h2>
				<Clipboard
				  text={parseInputspec(compspec)}
				  let:copy
					on:copy={handleCopied}>
					<button on:click={copy}>{copyState}</button>
				</Clipboard>
			</div>
			<textarea class="results">{parseInputspec(compspec)}</textarea>
		</TabPanel>
	</Tabs>
</div>

<script>
	import { Tabs, Tab, TabList, TabPanel } from 'svelte-tabs';
	import Clipboard from "svelte-clipboard";
  import BasicsUI from './BasicsUI.svelte';
  import SelectsUI from './SelectsUI.svelte';

	import {
		fieldHelper,
		parseCompspec,
		parseInputspec
	} from './Helpers.js';

	let basics = {
    "meta": {
      "name": 'A COINSTAC Computation Demo',
			"id": 'coinstac-computation',
			"repository": 'https://github.com/username/projectname',
			"description": 'A Decentralized Analysis on Data',
			"version": "v1.0.0",
			"compspecVersion": 2
    },
		"computation": {
			"type": "docker",
			"dockerImage": "coinstacteam/coinstac-computation",
			"command": [
				"python"
			],
			"remote": {
				"type": "docker",
				"dockerImage": "coinstacteam/coinstac-computation",
				"command": [
					"python"
				]
			},
			"input": {},
			"output": {},
			"display": {
				"type": "string"
			}
		}
  };
	$: basics = basics;
	let selects = [];
	$: selects = fieldHelper(selects);
	$: compspec = parseCompspec(basics,selects);

	let copyState = 'Copy To Clipboard';

	let handleCopied = (() => {
		copyState = 'Copied';
		setTimeout(() => {
			copyState = 'Copy To Clipboard';
		}, 5000)
	});
</script>


<style>
	.results {
		width: 100%;
		min-height: 80vh;
		font-size: 0.75rem;
	}
</style>
